export const setList = (state, payload) => state.list = payload;
export const setMetaList = (state, payload) => state.metaList = payload;
